import { useState } from "react";
import FormSmallTextField from "../components/common/form/FormTextField";
import FormTitle from "../components/common/form/FormTitle";
import {
  Box,
  Button,
  Container,
  Link,
  Paper,
  Stack,
} from "@mui/material";
import PageTitle from "../components/common/pages/PageTitle";
import { useStores } from "../../use-stores";
import { useNotification } from "../../utils/NotificationsContext";
import { Link as RouterLink } from "react-router-dom";
import { observer } from "mobx-react-lite";
import CustomTypography from "../components/common/form/CustomTypography";

const paperSx = {
  padding: { xs: 3, sm: 4 },
  mb: 4,
  borderRadius: 3,
  border: "1px solid",
  borderColor: "divider",
  background:
    "linear-gradient(180deg, rgba(100,85,237,0.08) 0%, rgba(255,255,255,0) 48%)",
};

const ForgetPassword = () => {
  const { userStore } = useStores();
  const { showError, showSuccess } = useNotification();
  const [email, setEmail] = useState("");

  const resetForm = () => {
    if (email === "") {
      showError("Validation Error", "Email is required.");
      return false;
    }
    userStore
      .resetPassword(email)
      .then(() => {
        showSuccess("Reset password link sent successfully");
      })
      .catch((reason: any) =>
        showError(
          "Error!",
          reason?.response?.data?.message ||
          "Something went wrong! Please try again later.",
        ),
      );
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2,
        py: 4,
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 440 }}>
        <Stack sx={{ mb: 1.5 }}>
          <PageTitle title="Forgot password" />
          <CustomTypography variant="body2" color="text.secondary" sx={{ fontSize: "12px" }}>
            Enter your account email and we will send you a link to reset your
            password.
          </CustomTypography>
        </Stack>

        <Paper elevation={0} sx={paperSx}>
          <Stack spacing={2.5}>
            <Box>
              <FormTitle fontSize="12px" title="Email" marginBottom={1} />
              <FormSmallTextField
                label="Email address"
                required
                variant="outlined"
                fontSize="12px"
                type="email"
                value={email}
                onChange={(id, value) => setEmail(value!)}
              />
            </Box>

            <Button
              variant="contained"
              color="primary"
              size="large"
              fullWidth
              onClick={resetForm}
            >
              Send reset link
            </Button>

            <CustomTypography variant="body2" color="text.secondary" sx={{ fontSize: "12px", textAlign: "center" }}>
              <Link component={RouterLink} to="/login" underline="hover">
                Back to sign in
              </Link>
            </CustomTypography>
          </Stack>
        </Paper>
      </Box>
    </Container>
  );
};

export default observer(ForgetPassword);
